module.exports = __webpack_public_path__ + "img/gateway-and-embedded.09511e7f.webp";